module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dShTYRBEAXgt5CQU39AYcCjTlMOHQDuHBpF6AA6oQZoAQTuckFhlqUDBre571NjNtm8zJsEAAAAAAAAAABgT7X8w3K2vuvJzRiPM4dt6/1p9/F2m6LDFC3n64cRzmaMq8xjldYuj5bT9r37fKk8PEhR77nKpEZdrlNUDmjf1Dcoecykxt+fU1S+Qb8dHl0+Get6kXnu0HaEc//1/roJAAAAAAAAAAAAf/MDZ6sfEq9UjUIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minus-black.png
// module id = 702
// module chunks = 0